import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryLastReviewIsApproved,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEntryLastReviewIsApproved } from 'services/myTimesheetEntries/selectors';

interface OwnProps extends MyTimesheetEntriesProps {
    children: React.ReactElement | string;
    FallbackComponent?: React.ReactElement | string;
}

interface ConnectedProps {
    lastReviewIsApproved?: MyTimesheetEntryLastReviewIsApproved;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryLastReviewIsUnapprovedGate extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | string | null {
        const {
            lastReviewIsApproved,
            children,
            FallbackComponent
        } = this.props;
        if (lastReviewIsApproved) {
            return FallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    lastReviewIsApproved: makeSelectMyTimesheetEntryLastReviewIsApproved()
});

export default connect(mapStateToProps)(
    MyTimesheetEntryLastReviewIsUnapprovedGate
);
